import { Print } from "@mui/icons-material";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import ImageViewDialog from "../mui/imageViewDialog";
import { IMAGE_BASE_URL } from "../data/API_LINKS";

export default function ReportView({ data }) {
  const [imageToView, setImageToView] = useState(null);

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const doct = document.getElementById("main").innerHTML;
    printWindow.document.write("<html><head><title>Print</title></head><body>");
    printWindow.document.write(doct);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div
      id={"main"}
      className="flex flex-1 flex-row p-1 gap-1 mt-5"
      style={{
        boxShadow: "0px 0px 2px 1px rgba(0,0,0,0.2)",
        padding: "10px",
        borderRadius: "10px",
      }}
    >
      <ImageViewDialog
        open={imageToView != null}
        imageUrl={imageToView}
        onClose={() => setImageToView(null)}
      />
      <div style={{ flex: 1 }} className="flex flex-col  mb-1">
        <p style={{ fontSize: "16px" }} className=" font-normal text-green-600">
          Name:
          <span className="text-black">
            {" "}
            {data?.user?.first_name + " " + data?.user?.last_name}
          </span>
        </p>

        <p style={{ fontSize: "16px" }} className=" font-normal text-blue-500">
          Date & Time:
          <span className="text-black"> 20-02-2023 10:21AM</span>
        </p>
        <p
          style={{ fontSize: "16px" }}
          className=" font-normal text-orange-600"
        >
          Type:<span className="text-black"> {data?.user?.user_type}</span>
        </p>
        <p style={{ fontSize: "16px" }} className=" font-normal text-red-500">
          Reason:
          <span className="text-black"> {data?.detail?.reason}</span>
        </p>

        <p
          style={{
            fontSize: "16px",
            color: "rgba(0,0,0,0.8)",
            marginBottom: "4px",
          }}
        >
          Order Ticket Screenshot:
        </p>
        <img
          onClick={() =>
            setImageToView(IMAGE_BASE_URL + data?.detail?.proof_img)
          }
          style={{
            maxHeight: "460px",
            maxWidth: "280px",
            background: "red",
            padding: "4px",
            borderRadius: "8px",
            marginTop: "4px",
          }}
          src={IMAGE_BASE_URL + data?.detail?.proof_img}
          alt="Full-screen"
          className="max-h-full"
        />
      </div>

      <div
        style={{
          width: "1px",
          background: "rgba(0, 0, 0, 0.2)",
          borderRadius: "15px",
          marginInlineStart: "5px",
          marginInlineEnd: "5px",
        }}
      />

      <div style={{ flex: 1 }} className=" flex flex-col">
        <p
          style={{
            fontSize: "16px",
            color: "rgba(0,0,0,0.8)",
            marginBottom: "4px",
          }}
        >
          Message
        </p>
        <TextField
          className="w-full"
          rows={4}
          multiline
          color="error"
          InputProps={{
            readOnly: true,
          }}
          defaultValue={data?.detail?.message}
        />
        <p
          style={{
            fontSize: "16px",
            color: "rgba(0,0,0,0.8)",
            marginBottom: "4px",
            textAlign: "center",
          }}
        >
          Proof Picture
        </p>
        <img
          onClick={() =>
            setImageToView(IMAGE_BASE_URL + data?.detail?.additional_img)
          }
          style={{
            maxHeight: "260px",
            maxWidth: "260px",
            background: "red",
            padding: "4px",
            borderRadius: "8px",
            marginTop: "8px",
            alignSelf: "center",
          }}
          src={IMAGE_BASE_URL + data?.detail?.additional_img}
          alt="Full-screen"
          className="max-h-full"
        />
        <Button
          onClick={() => handlePrint()}
          color={"primary"}
          variant="contained"
          sx={{ paddingX: "13px", maxWidth: "100px", alignSelf: "end" }}
        >
          <Print sx={{ marginInlineEnd: "10px" }} />
          Print
        </Button>
      </div>
    </div>
  );
}
